module.exports = __webpack_public_path__ + "assets/swiper.bf0fb04b.svg";